/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { s as safeJSONParse } from './safe-data-66f20265.js';
import { l as lodash_get } from './index-6f6b9acc.js';

var getResumeCallBackData = function (e) {
    var _a;
    var data = lodash_get(e, 'param.backData') ||
        lodash_get(e, 'param.data.backData') ||
        lodash_get(e, 'param.data') ||
        lodash_get(e, 'data');
    return typeof data === 'string' ? (_a = safeJSONParse(data)) !== null && _a !== void 0 ? _a : data : data;
};
var getLocalStorage = function (key) {
    var _a, _b;
    var valueString = (_a = localStorage.getItem(key)) !== null && _a !== void 0 ? _a : '';
    var value = (_b = safeJSONParse(valueString)) !== null && _b !== void 0 ? _b : valueString;
    return value;
};
var setLocalStorage = function (key, value) {
    var stringValue = typeof value === 'string' ? value : JSON.stringify(value);
    localStorage.setItem(key, stringValue);
};
/**
 * 咸鱼端的onResume事件，由于端容器事件不带数据，所以需要使用localStorage进行数据传递
 */
var RESUME_DATA_FOR_FM = '__RESUME_DATA_FOR_FM__';
var getResumeDataForFm = function () { return getLocalStorage(RESUME_DATA_FOR_FM); };
var saveResumeDataForFm = function (data) {
    setLocalStorage(RESUME_DATA_FOR_FM, data);
};
/**
 * 获取真正的url,发送给端jsbridge
 * 背景：https://alidocs.dingtalk.com/i/nodes/QjXmLRyz4G5VGkmnQ3ZzVZpaD19v6NK2# 「【navigateTo API】支持hash、history补全」
 * hash确定规则：1. isHash = true  或 2. url以 `#/`或`/#/`开头
 */
var getRealWebUrl = function (options) {
    var _a;
    var _b = options !== null && options !== void 0 ? options : {}, _c = _b.url, url = _c === void 0 ? '' : _c, isHash = _b.isHash;
    var useHashUrl = typeof isHash === 'undefined' ? /^(\/)?#\//g.test(url) : isHash;
    if (useHashUrl) {
        var _d = (_a = window === null || window === void 0 ? void 0 : window.location) !== null && _a !== void 0 ? _a : {}, hash = _d.hash, href = _d.href;
        if (hash) {
            return href.replace(hash, url);
        }
        // 类似http://www.xx.xx 纯网址，此时hash值为''
        return href + url;
    }
    return url;
};

export { getRealWebUrl as a, getResumeDataForFm as b, getResumeCallBackData as g, saveResumeDataForFm as s };
